import { useEffect, useState } from "react";
import axios from "axios";
import { Mail, Phone, Building2, User, MessageSquare, Calendar, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/leads`);
        setLeads(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen px-6 md:px-12 py-12" data-testid="admin-page">
      <div className="max-w-7xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 mb-6" data-testid="admin-back-link">
          <ArrowLeft size={16} /> Voltar ao site
        </Link>
        <div className="flex items-center justify-between mb-10">
          <div>
            <p className="label-eyebrow">PAINEL INTERNO</p>
            <h1 className="font-display text-4xl md:text-5xl mt-2">Leads Capturados</h1>
            <p className="text-[#8892B0] mt-2">Total: <span className="text-white font-semibold" data-testid="admin-total-leads">{leads.length}</span></p>
          </div>
        </div>

        {loading ? (
          <p className="text-[#8892B0]">Carregando...</p>
        ) : leads.length === 0 ? (
          <div className="card-surface p-12 text-center">
            <p className="text-[#8892B0]">Nenhum lead cadastrado ainda.</p>
          </div>
        ) : (
          <div className="grid gap-4" data-testid="admin-leads-list">
            {leads.map((lead) => (
              <div key={lead.id} className="card-surface p-6" data-testid={`lead-card-${lead.id}`}>
                <div className="grid md:grid-cols-3 gap-4">
                  <div>
                    <p className="label-eyebrow mb-2">Contato</p>
                    <p className="flex items-center gap-2 text-white"><User size={14} className="text-cyan-400" />{lead.name}</p>
                    <p className="flex items-center gap-2 text-[#8892B0] text-sm mt-1"><Mail size={14} className="text-cyan-400" />{lead.email}</p>
                    {lead.phone && <p className="flex items-center gap-2 text-[#8892B0] text-sm mt-1"><Phone size={14} className="text-cyan-400" />{lead.phone}</p>}
                  </div>
                  <div>
                    <p className="label-eyebrow mb-2">Empresa</p>
                    <p className="flex items-center gap-2 text-white"><Building2 size={14} className="text-cyan-400" />{lead.company || "-"}</p>
                    <p className="text-[#8892B0] text-sm mt-1">{lead.role || "-"}</p>
                    {lead.interest && <p className="text-cyan-400 text-xs mt-2 font-mono-tech uppercase tracking-wider">Interesse: {lead.interest}</p>}
                  </div>
                  <div>
                    <p className="label-eyebrow mb-2 flex items-center gap-1"><Calendar size={12} />{new Date(lead.created_at).toLocaleString("pt-BR")}</p>
                    <p className="flex items-start gap-2 text-[#8892B0] text-sm mt-1"><MessageSquare size={14} className="text-cyan-400 mt-1 shrink-0" /><span>{lead.message}</span></p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
